var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "quotetool__step",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitForm.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("h2", { staticClass: "quotetool__step-heading" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.labels.stepDropoutStepTitle) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "quotetool__step-form-container" }, [
          _c("p", [_vm._v(_vm._s(_vm.labels.stepDropoutStepDescription))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }